import $ from 'jquery';
import 'slick-carousel';

$(() => {
	const $carousel = $('#brand-home-carousel');
	const $inner = $carousel.find('.banner-slider-inner');
	const $actions = $carousel.find('.banner-action');

	const calculatePosition = () => {
		$inner.css('top', 'auto');
		$actions.css('bottom', 'calc(2rem + 23px)');

		const $carouselHeight = $carousel.outerHeight();
		const $innerHeight = $inner.outerHeight();
		const diff = $carouselHeight - $innerHeight;

		if (diff >= 0) {
			return;
		}

		const top = Math.abs(diff / 2);

		$inner.css('top', -top);
		$actions.css('bottom', `calc(2rem + 23px + ${top}px)`);
	};

	$(window)
		.on('resize', () => calculatePosition())
		.trigger('resize');

	$carousel.on('slid.bs.carousel', () => {
		setTimeout(() => calculatePosition(), 0);
	});

	$('.slick-carousel').each((index, carousel) => {
		const $slider = $(carousel);

		$slider.slick({
			infinite: true,
			dots: false,
			arrows: false,
			centerMode: true,
			centerPadding: '0'
		});

		$slider.closest('.slick-slider-area').find('.slick-prev').on('click', () => $slider.slick('slickPrev'));
		$slider.closest('.slick-slider-area').find('.slick-next').on('click', () => $slider.slick('slickNext'));
	});

	(() => {
		const doAnimations = elements => {
			elements.each(function (index, element) {
				let $element = $(element);
				let $animationType = $element.data('animation');

				$element
					.addClass($animationType)
					.one('webkitAnimationEnd animationend', () => $element.removeClass($animationType));
			});
		};

		const $myCarousel = $('#carousel-example-generic');
		const $firstAnimating = $myCarousel.find('.item:first').find('[data-animation^="animated"]');

		$myCarousel.carousel();

		doAnimations($firstAnimating);

		$myCarousel.carousel('pause');

		$myCarousel.on('slide.bs.carousel', event => {
			const $animating = $(event.relatedTarget).find('[data-animation^="animated"]');

			doAnimations($animating);
		});

		$myCarousel.carousel({
			interval: 3000,
			pause: false,
		});
	})();
});



// WEBPACK FOOTER //
// ./resources/js/app/carousel.js